import { Box } from '@mui/material';

import { TAGBrand } from '@/types';
import TAGSvgIcon from '@/components/TAGSvgIcon/TAGSvgIcon';

import { wrapper, colorBlock } from './FooterBanner.styles';

const FooterBanner = () => {
	const brands = [
		{ id: 'aspen-dental', name: TAGBrand.AspenDental },
		{ id: 'clear-choice', name: TAGBrand.ClearChoice },
		{ id: 'chapter', name: TAGBrand.Chapter },
		{ id: 'wellnow', name: TAGBrand.WellNow },
		{ id: 'lovet', name: TAGBrand.Lovet },
	];

	const getBrandColor = (brand: TAGBrand): string => {
		// Fallback to hardcoded values if needed
		switch (brand) {
			case TAGBrand.AspenDental:
				return '#184EB1';
			case TAGBrand.ClearChoice:
				return '#F19A31';
			case TAGBrand.Chapter:
				return '#AD1670';
			case TAGBrand.WellNow:
				return '#CD0E2D';
			case TAGBrand.Lovet:
				return '#3D8132';
			default:
				return 'neutrals.transparent';
		}
	};

	const getImgSrc = (
		brand: TAGBrand
	):
		| 'TeamTagAspenDentalLogo'
		| 'TeamTagClearChoiceLogo'
		| 'TeamTagChapterLogo'
		| 'TeamTagWellnowLogo'
		| 'TeamTagLovetLogo' => {
		switch (brand) {
			case TAGBrand.AspenDental:
				return 'TeamTagAspenDentalLogo'; // Use the imported AspenDentalLogo component
			case TAGBrand.ClearChoice:
				return 'TeamTagClearChoiceLogo'; // Replace with the actual path to the ClearChoice logo';
			case TAGBrand.Chapter:
				return 'TeamTagChapterLogo'; // Replace with the actual path to the Chapter logo';
			case TAGBrand.WellNow:
				return 'TeamTagWellnowLogo';
			case TAGBrand.Lovet:
				return 'TeamTagLovetLogo';
			default:
				return 'TeamTagAspenDentalLogo';
		}
	};

	const getViewBox = (brand: TAGBrand): string => {
		switch (brand) {
			case TAGBrand.AspenDental:
				return '0 0 104 18';
			case TAGBrand.ClearChoice:
				return '0 0 126 38';
			case TAGBrand.Chapter:
				return '0 0 92 40';
			case TAGBrand.WellNow:
				return '0 0 115 30';
			case TAGBrand.Lovet:
				return '0 0 104 22';
			default:
				return '0 0 36 36';
		}
	};

	return (
		<Box sx={wrapper} data-test-id="section_footerbanner">
			{brands.map((brand) => (
				<Box key={brand.id} sx={colorBlock(getBrandColor(brand.name))}>
					<TAGSvgIcon
						icon={getImgSrc(brand.name)} // Use the correct string identifier for the icon
						size={100} // Set a default size for the icon
						viewBox={getViewBox(brand.name)} // Ensure the viewBox is set correctly for the icon
						dataTestId={`footer-banner-icon-${brand.id}`} // Unique test ID for each brand icon
					/>
				</Box>
			))}
		</Box>
	);
};

export default FooterBanner;
